import { H1 } from "../../components/Text/Text";
import WaitForEncodingFooter from "./WaitForEncodingFooter";
import WaitForEncodingPopupBody from "./WaitForEncodingPopupBody";

import styles from './styles.module.scss';

export default ({
    header: <H1 className={styles.header}>Please wait for the encoding process to be completed</H1>,
    body: <WaitForEncodingPopupBody />,
    footer: <WaitForEncodingFooter />,
    className: styles.popupWrapper,
});